import { useState } from "react";

import Logo from "../../component/header/Logo.js";
import Nav from "../../component/header/Nav.js";

function Sidebar() {
  console.log ("Sidebar component rendered");
  // Setting the state for hovering effect
  const [isHovered, setIsHovered] = useState(false);

  // Returned JSX
  return (
    <aside
    className={`fixed left-0 top-0 bottom-0 py-5 px-8 flex flex-col z-30 transition-all duration-200 w-[7.5rem] ${
      isHovered ? "sidebar--expanded" : "border-r border-red-500"
    }`}
      style={{
        backgroundImage:
          "linear-gradient(to right, var(--color-black) 40%, transparent)",
      }}
      // onMouseEnter={() => setIsHovered(true)}
      // onMouseLeave={() => setIsHovered(false)}
    >
      <Logo />
      <Nav />
    </aside>
  );
}

export default Sidebar;
